export class GlobalRole {
    code: string;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/models/globalRole.ts